module.exports = __webpack_public_path__ + "static/media/Miami-ryan-parker.a95fffca.jpg";